<ng-container [ngSwitch]="statetype">
  <ng-container *ngSwitchCase="StateTypeEnum.UPLOAD">
    <div class="ui placeholder segment empty-state-container">
      <div class="ui icon header">
        <div class="status-image empty-upload-image"></div>
        can’t find any advertisement on signgaze?
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="StateTypeEnum.TABLE">
    <div class="ui placeholder segment empty-state-container">
      <div class="ui icon header status-heading">
        <div class="status-image empty-table-image"></div>
        Nothing in the bucket at the moment
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="StateTypeEnum.ERROR">
    <div class="ui placeholder segment empty-state-container">
      <div class="ui icon header status-heading">
        <div class="status-image empty-error-image"></div>
        Page not found!
      </div>
      <button class="ui primary large button">Check Listings</button>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="StateTypeEnum.OFFLINE">
    <div class="ui placeholder segment empty-state-container">
      <div class="ui icon header status-heading">
        <div class="status-image empty-offline-image"></div>
        Connection lost
      </div>
    </div>
  </ng-container>
</ng-container>
